import React from 'react';
import NotificationsPage from '../Notificaciones/NotificationsPage';
import Navigation from '../Layouts/Navigation/Navigation';

export default function AdminNotificaciones() {
  return <NotificationsPage NavigationComponent={Navigation} />;
}
